import React, { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  FlatList,
  TextInput,
  TouchableOpacity,
  ScrollView,
  useWindowDimensions,
} from 'react-native';
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedItems, updateSelectedRequestItems } from '../../../Redux/Reducers/guestRequestReducer';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { CROSS } from '../../../assets';
import CustomPressable from '../../../components/customPressable/customPressable';
import { setGoHome } from '../../../Redux/Reducers/appConfigReducer';
import CustomFlatList from '../../../components/customFlatList';
import { generateToken, getCleanUrl } from '../../../utils/Helper';
import { sendGuestRequest } from '../../../Redux/Actions/guestRequestAction';
import FetchingDataScreen from '../../../components/fetchingDataScreen';
import { CustomTextInput } from '../../../components/customTextInput';
import { useFocusEffect, useRoute } from '@react-navigation/native';
import { sendAnalytics } from '../../../Redux/Actions/analyticsAction';
import { GUEST_REQUEST_CATEGORY } from '../../../config/Constant';
import RenderHTML from 'react-native-render-html';
import { getStyleForRenderHTML } from '../../../js/utility';


const GuestRequestDetails_Landscape = ({ navigation }) => {

  const route = useRoute();
  const { widgetDisplayName, guestRequestSessionId} = route.params || {};
  

  const { currentWidget } = useSelector(state => state.deviceConfigSlice);
  const storeName = currentWidget?.displayName; 
  


  const dispatch = useDispatch();
  const getStyles = useCssStyle();
  const { t } = useTranslation();
  const {width} = useWindowDimensions();


  const { selectedItems } = useSelector(state => state.guestRequestSlice);

  const [loaderState, setLoaderState] = useState({
    showLoader: false,
    loaderMessage: ""
  });

  const toggleLoaderState = (state, message) => {
    setLoaderState({
      showLoader: state,
      loaderMessage: state ? message : ""
    })
  }



  const [additionalDetails, setAdditionalDetails] = useState('');





  const placeRequest = async () => {

    toggleLoaderState(true, "Placing order...");


    const requestDetails = selectedItems.map(item => ({
      serviceRequestId: item.serviceRequestId,
      quantity: 1,
      additionalNote: additionalDetails
    }));

    const requestResponse = await dispatch(sendGuestRequest(requestDetails));

    toggleLoaderState(false, "");
    dispatch(sendAnalytics(GUEST_REQUEST_CATEGORY, requestResponse.status == "SUCCESS" ? "GUESTREQUEST - SUCCESS" : "GUESTREQUEST - FAILED", { element: "widget", "widgetSessionId": guestRequestSessionId, storeSku: currentWidget.storeSku, storeName: storeName, errorMessage: requestResponse.message, }));
    if (requestResponse.status == "SUCCESS") {
      dispatch(clearSelectedItems());
    }
  }






  const handleRemoveItem = item => {
    dispatch(updateSelectedRequestItems(item));
  };



  const handleGoBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }

    dispatch(setGoHome(true));
  }

  useEffect(() => {
    if (selectedItems.length === 0) {
      handleGoBack();
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);


  useEffect(() => {
    dispatch(sendAnalytics(GUEST_REQUEST_CATEGORY, "GUESTREQUEST MYORDER PAGE", { element: "widget", "widgetSessionId": guestRequestSessionId, storeSku: currentWidget.storeSku, storeName: storeName}))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const renderItem = (item) => (

    <View style={getStyles(['list_itemContainer', 'guestrequestdetails_landscape_itemContainer'])} id='list_itemContainer guestrequestdetails_landscape_itemContainer'>

      <View style={getStyles(['list_itemContainer_image', 'guestrequestdetails_landscape_itemContainer_image'])} id="list_itemContainer_image guestrequestdetails_landscape_itemContainer_image">
          <ImageComp
            source={getCleanUrl(item?.imageName)}
            style={getStyles(['guestrequestdetails_landscape_item_image'])}
            id="guestrequestdetails_landscape_item_image"
          />
      </View>

      <View style={getStyles(['list_itemContainer_textContainer', 'guestrequestdetails_landscape_itemContainer_textContainer'])}>
        {item?.name && <Text style={getStyles(['list_itemContainer_textContainer_title', 'guestrequestdetails_landscape_itemContainer_textContainer_title'])} id='list_itemContainer_textContainer_title guestrequestdetails_landscape_itemContainer_textContainer_title'>{item.name}</Text>}
        {item?.description && <Text style={getStyles(['list_itemContainer_textContainer_subtitle', 'guestrequestdetails_landscape_textContainer_subtitle'])} numberOfLines={2} ellipsizeMode="tail" id="list_itemContainer_textContainer_subtitle guestrequestdetails_landscape_textContainer_subtitle">{item.description}</Text>}
      </View>

      <CustomPressable onPress={() => handleRemoveItem(item)} style={getStyles(['list_itemContainer_arrow', 'guestrequestdetails_landscape_itemContainer_arrow'])} id="list_itemContainer_arrow guestrequestdetails_landscape_itemContainer_arrow">
        <ImageComp source={CROSS} style={getStyles(['list_itemContainer_arrow_img', 'guestrequestdetails_landscape_itemContainer_arrow_img'])} id="list_itemContainer_arrow_img guestrequestdetails_landscape_itemContainer_arrow_img"/>
      </CustomPressable>
    </View>
  );

  const customGuestRequestDetailsTitleStyle = getStyles([
    'widgetmainContainerHeaderTitle',
    'guestrequestdetails_landscape_HeaderTitle'
  ]);

  const { baseStyle: titleBaseStyle, systemFonts: titleSystemFonts } = getStyleForRenderHTML(customGuestRequestDetailsTitleStyle);

  const renderHeader = () => (
    <View style={getStyles(['widgetmainContainerHeaderContainer', 'guestrequestdetails_landscape_HeaderContainer'])} id='widgetmainContainerHeaderContainer guestrequestdetails_landscape_HeaderContainer'>
      <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'guestrequestdetails_landscape_HeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer guestrequestdetails_landscape_HeaderTitleContainer'>
            <RenderHTML 
              contentWidth={width}
              baseStyle={titleBaseStyle}
              source={{html: t("guestRequest.my_request")}}
              // Manipulate text color
              domVisitors={{
                onElement: (element) => {
                  if (
                    element.name === 'div' &&
                    element.attribs &&
                    element.attribs.style
                  ) {

                    const styles = element.attribs.style
                      .split(';')
                      .filter((s) => !s.trim().startsWith('color'))
                      .concat(`color:${titleBaseStyle.color || "white"}`);

                    element.attribs.style = styles.join(';');
                  }
                },
              }}
              systemFonts={titleSystemFonts}
              id={`widgetmainContainerHeaderTitle guestrequestdetails_landscape_HeaderTitle`}
            />
      </View>
   </View>
  )

  return (
    <View style={getStyles(['widgetRootContainer', 'guestrequestdetails_landscape_RootContainer'])} id='widgetRootContainer guestrequestdetails_landscape_RootContainer'>
      <HeaderWithBack handleCustomBackPress={handleGoBack} />

      <ScrollView automaticallyAdjustKeyboardInsets={true} 
        contentContainerStyle={getStyles(['widgetmainContainer', 'guestrequestdetails_landscape_MainContainer'])} 
        id='widgetmainContainer guestrequestdetails_landscape_MainContainer'
      >
        {renderHeader()}


        <View style={getStyles(['widgetmainContainerChildContainer', 'guestrequestdetails_landscape_MainContainerChildContainer'])} id='widgetmainContainerChildContainer guestrequestdetails_landscape_MainContainerChildContainer' >
            {selectedItems?.map(renderItem)}
        </View>
        
        <View style={getStyles(['guestrequestdetails_landscapeFooterCotainer'])} id='guestrequestdetails_landscapeFooterCotainer'>
          <View style={getStyles(['textContainer'])} id='textContainer'>
            <Text style={getStyles(['label'])} id='label'>{t('guestRequest.additional')}</Text>
            <CustomTextInput
              style={{ height: 100 }}
              value={additionalDetails}
              onChangeText={setAdditionalDetails}
              placeholder="Add your special requests here"
              multiline
              numberOfLines={3}
            />
          </View>
        </View>
      </ScrollView>
      <View style={getStyles(['footer_button_container', 'guestrequestdetails_landscape_buttonContainer'])} id='footer_button_container guestrequestdetails_landscape_buttonContainer'>

        <CustomPressable style={getStyles(['primaryBtn'])} onPress={placeRequest} id="primaryBtn">
          <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('guestRequest.send_request')}</Text>
        </CustomPressable>
      </View>
      


      {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
    </View>
  );
};

export default GuestRequestDetails_Landscape;
